export default class Http {

  constructor(options) {
    this.options = options
  }

  request(callback, request) {
    const options = this.options,
      method = request.method || options.method || 'POST',
      responseType = request.responseType || options.responseType || 'text',
      isPost = method === 'POST',
      enctype = isPost ? (request.enctype || options.enctype || 'application/x-www-form-urlencoded') : undefined

    var xhr = new XMLHttpRequest()

    const
      getResponse = function () {
        const isText = responseType === 'text',
          headers = {}
        xhr.getAllResponseHeaders().split('\n').forEach(item => {
          const segments = item.split(/: /)
          headers[segments[0]] = segments[1]
        })

        return {
          status: {
            code: xhr.status,
            text: xhr.statusText
          },
          headers: headers,
          response: isText ? xhr.responseText : xhr.response
        }
      },

      sendResponse = function () {
        callback(getResponse())
      }

    xhr.addEventListener('load', event => {
      sendResponse()
    })

    xhr.addEventListener('error', event => {
      sendResponse()
    })

    xhr.addEventListener('abort', event => {
      sendResponse()
    })


    let headers = options.headers || {},
      url = this.options.url + (request.url || ''),
      data

    if (request.headers) {
      for (const key in request.headers) {
        headers[key] = request.headers[key]
      }
    }

    const reqData = request.data,
      hasData = reqData && Object.keys(reqData).length > 0

    if (!isPost && hasData) {
      url += '?' + this.URLencodeData(reqData)
    }

    xhr.open(method, url)

    if (enctype) {
      headers['Content-Type'] = enctype
      if (hasData) {
        switch (enctype) {
          case 'application/json':
            data = JSON.stringify(reqData)
            break

          default:
            data = this.URLencodeData(reqData)
        }
      }
    }

    if (responseType) {
      xhr.responseType = responseType
    }

    if (headers) {
      for (const key in headers) {
        xhr.setRequestHeader(key, headers[key])
      }
    }

    xhr.send(data)
  }


  URLencodeData(data) {
    let str = ''
    for (const key in data) {
      const value = data[key]
      if (value === null || value === undefined) {
        continue
      }

      if (str) {
        str += '&'
      }

      str += key + '=' + encodeURIComponent(value)
    }
    return str
  }
}